import React, { useEffect, useState, useRef } from 'react'
import './index.less'
import TabsBar from '../../components/tabs-bar'
import {
  ErrorPlaceholder,
  EmptyPlaceholder,
} from "../../../../components/placeholder"
import LoadingPage from "../../../../components/loading-page"
import Toast from '../../../../components/toast'
import LoadingMore from '../../../../components/loading-more';
import {
  formatTs
} from '../../../../utils/common'
import {
  goToPage
} from '../../utils'
import { DEFAULT_ERROR_MSG, MALL_ENTRY, curEnvMallDetailPageUrl } from '../../config';
import { getCurrentUid } from '../../../../api/web-h5-common';
import {
  GetUserMembership,
  GetXpOwnerPrivilege,
  PostUserMemberCardRecords,
  GetQueryMyGoodsRecord
} from '../../api'
import {
  MemberCardRecords,
  CouponPackRecords
} from '../../types'
import { trackGdp } from '../../../../utils/gio-report';

const App = () => {
  const uid = useRef('')
  const tabItems = [
    {
      key: 'card',
      title: '充电VIP卡',
      onClick: () => {
        clickTab('card')
      }
    },
    {
      key: 'coupon',
      title: 'VIP卡券',
      onClick: () => {
        clickTab('coupon')
      }
    }
  ]
  const ICON_MAP = {
    'card': require('../../assets/charge_card.png'),
    'coupon': require('../../assets/charge_coupon.png'),
    'storedCard' : require('../../assets/stored_card.svg')
  }
  const CARD_STATE_MAP = {
    0: ['待生效', 'pending'],
    1: ['生效中', 'effective'],
    2: ['已失效', 'invalid'],
    3: ['已过期', 'invalid']
  }
  const COUPON_STATE_MAP = {
    1: ['发放成功', 'effective'],
    2: ['已失效', 'invalid']
  }

  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingError, setIsLoadingError] = useState(false)
  const [isEmptyPage, setIsEmptyPage] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')

  // 上拉加载
  const recordsRef = useRef<any>(null)
  const finishLoadCard = useRef(false)
  const finishLoadCoupon = useRef(false)
  const isLoadingMore = useRef(false)
  const [loadingMore, setLoadingMore] = useState(false)
  const reqCardParams = useRef({
    uid: '',
    pageNo: 1,
    pageSize: 10,
  })
  const reqCouponParams = useRef({
    uid: '',
    pageNo: 1,
    pageSize: 10
  })

  const [curTab, setCurTab] = useState<'card' | 'coupon'>('card')
  const [isXpOwner, setIsXpOwner] = useState(false)
  const [xpOwnerPrivilegeImgJumpUrl, setXpOwnerPrivilegeImgJumpUrl] = useState({
    imgUrl: '',
    jumpUrl: ''
  })
  const memberCardRecordsTotal = useRef(0)
  const couponPackRecordsTotal = useRef(0)
  const [memberCardRecords, setMemberCardRecords] = useState<MemberCardRecords[]>([])
  const [couponPackRecords, setCouponPackRecords] = useState<CouponPackRecords[]>([])

  useEffect(() => {
    document.title = '获得记录'

    setIsLoading(true)
    getCurrentUid().then(userId => {
      uid.current = userId
      getUserMembership()
      reqCardParams.current.uid = uid.current
      reqCouponParams.current.uid = uid.current
      getUserMemberCardRecords(reqCardParams.current)
      getUserCouponPackRecords(reqCouponParams.current)
    }).catch(() => {})

    // 上报埋点
    trackGdp('P11223', 'B001', {
      tabType: 'card'
    })
  }, [])

  const getUserMembership = async () => {
    try {
      const res: any = await GetUserMembership({ uid: uid.current })
      if (res.code === 200) {
        if (res.data?.userType === 1) {
          setIsXpOwner(true)
          getXpOwnerPrivilege()
        }
      } else {
        setIsLoading(false)
        setErrorMsg(DEFAULT_ERROR_MSG)
        setIsEmptyPage(true)
      }
    } catch (error) {
      console.log('getUserMembership error -->', error)
      setIsLoading(false)
      setErrorMsg(DEFAULT_ERROR_MSG)
      setIsLoadingError(true)
    }
  }

  const getXpOwnerPrivilege = async () => {
    try {
      const res: any = await GetXpOwnerPrivilege({ uid: uid.current })
      if (res.code === 200) {
        setXpOwnerPrivilegeImgJumpUrl({
          imgUrl: res.data.xpOwnerPrivilegeImgJumpUrl?.imgUrl,
          jumpUrl: res.data.xpOwnerPrivilegeImgJumpUrl?.jumpUrl
        })
      } else {
        setIsLoading(false)
        setErrorMsg(DEFAULT_ERROR_MSG)
        setIsEmptyPage(true)
      }
    } catch (error) {
      console.log('getXpOwnerPrivilege error --> ', error)
      setIsLoading(false)
      setErrorMsg(DEFAULT_ERROR_MSG)
      setIsLoadingError(true)
    }
  }

  // 下拉到底部，翻页加载更多数据
  const onGoodsListScroll = (e) => {
    const isScrollToBottom = e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight - 1
    if (isScrollToBottom) {
      const data = curTab === 'card' ? memberCardRecords : couponPackRecords
      const loadFinished = curTab === 'card' ? finishLoadCard.current : finishLoadCoupon.current
      if (!isLoadingMore.current && data.length > 0 && !loadFinished) {
        loadMoreData()
      }
    }
  }

  // 加载更多记录
  const loadMoreData = () => {
    setLoadingMore(true)
    isLoadingMore.current = true
    if (curTab === 'card') {
      reqCardParams.current.pageNo += 1
      getUserMemberCardRecords(reqCardParams.current, false)
    } else {
      reqCouponParams.current.pageNo += 1
      getUserCouponPackRecords(reqCouponParams.current, false)
    }
  }

  const getUserMemberCardRecords = async (params, firstLoad = true) => {
    try {
      const res: any = await PostUserMemberCardRecords(params)
      if (res.code === 200) {
        setIsLoading(false)
        if (firstLoad) {
          setMemberCardRecords(res.data?.records)
          memberCardRecordsTotal.current = res.data?.total
          if (res.data?.records?.length >= res.data?.total) {
            finishLoadCard.current = true
          }
        } else {
          const currentRecords = memberCardRecords.concat(res.data?.records)
          setMemberCardRecords(currentRecords)
          if (currentRecords.length >= memberCardRecordsTotal.current) {
            finishLoadCard.current = true
          }
        }
      } else {
        if (firstLoad) {
          setIsLoading(false)
          setErrorMsg(DEFAULT_ERROR_MSG)
          setIsEmptyPage(true)
        }
      }
    } catch (error) {
      console.log('getMemberCardRecords error --> ', error)
      if (firstLoad) {
        setIsLoading(false)
        setErrorMsg(DEFAULT_ERROR_MSG)
        setIsLoadingError(true)
      }
    } finally {
      setLoadingMore(false)
      isLoadingMore.current = false
    }
  }

  const getUserCouponPackRecords = async (params, firstLoad = true) => {
    try {
      const res: any = await GetQueryMyGoodsRecord(params)
      console.log('getUserCouponPackRecords', res)
      if (res.code === 200) {
        setIsLoading(false)
        setCouponPackRecords(res.data)
        finishLoadCoupon.current = true
      } else {
        if (firstLoad) {
          setIsLoading(false)
          setErrorMsg(DEFAULT_ERROR_MSG)
          setIsEmptyPage(true)
        }
      }
    } catch (error) {
      console.log('getUserCouponPackRecords error --> ', error)
      if (firstLoad) {
        setIsLoading(false)
        setErrorMsg(DEFAULT_ERROR_MSG)
        setIsLoadingError(true)
      }
    } finally {
      setLoadingMore(false)
      isLoadingMore.current = false
    }
  }

  const clickTab = (tab: 'card' | 'coupon') => {
    setCurTab(tab)
    setLoadingMore(false)
    isLoadingMore.current = false
    recordsRef.current && (recordsRef.current.scrollTop = 0)

    trackGdp('P11223', 'B001', {
      tabType: tab
    })
  }

  const showToast = (text: string) => {
    Toast.show({
      text,
      duration: 2000
    });
  }

  const clickOrderEntry = (item: any) => {
    if(item?.isLinkMallOrder === false) {
      showToast('好友转赠获得的购买订单，可在好友的小鹏APP-我的-商城订单查看购买订单详情')
      return
    }
    trackGdp('P11223', 'B002', {
      orderId: item?.bizId
    })
    goToPage(`${curEnvMallDetailPageUrl}${item?.bizId}?entry=${MALL_ENTRY}`)
  }

  const renderMemberCardRecords = () => {
    return <>
      {
        isXpOwner && (
          <div className='coupon-card-box mt-first'>
            <div className='title-bar'>
              <span className='info-left'>
                <img src={ICON_MAP['card']} alt='' className='icon' />
                <span className='title'>充电VIP卡：车主终身享特权</span>
              </span>
              <span className={`status effective`}>生效中</span>
            </div>
            <div className='content'>
              <img className='xp-owner-privilege-img' alt='' src={xpOwnerPrivilegeImgJumpUrl.imgUrl} onClick={() => goToPage(xpOwnerPrivilegeImgJumpUrl.jumpUrl)} />
            </div>
          </div>
        )
      }
      {
        memberCardRecords?.length > 0 ? memberCardRecords.map((item, index) => (
          <div className={`coupon-card-box ${!isXpOwner && index === 0 ? 'mt-first' : '' }`} key={index}>
            <div className='title-bar'>
              <span className='info-left'>
                <img src={ICON_MAP['card']} alt='' className='icon' />
                <span className='title'>
                  {`充电VIP卡：${item?.cardValidDays}天有效期`}
                </span>
              </span>
              <span className={`status ${CARD_STATE_MAP[item?.effectiveState][1]}`}>{CARD_STATE_MAP[item?.effectiveState][0]}</span>
            </div>
            <div className='content'>
              <div className='item'>
                <span className='label'>获得方式</span>
                <span className='value orange'>{item?.sourceName}</span>
              </div>
              <div className='item'>
                <span className='label'>获得时间</span>
                <span className='value'>{formatTs(item?.accessTime)}</span>
              </div>
              {
                [0,1,3].includes(item?.effectiveState) && (
                  <div className='item'>
                    <span className='label'>有效期</span>
                    <span className='value'>{`至${formatTs(item?.invalidTime)}`}</span>
                  </div>
                )
              }
              {
              // giftFlag 是否买赠，0-无赠送，1-赠送
                item?.giftFlag !== 0 &&
                <div className='item'>
                  <span className='label'>获得赠品</span>
                  <span className='value'>
                    {item?.giftType === 1 ? (
                      `${item?.giftName}（券数量：${item?.giftDesc}张）`
                    ) : (
                      `${item?.giftName}（面额：${item?.giftDesc}元）`
                    )}
                  </span>
                </div>
              }
              <div className='item'>
                <span className='label'>发放编号</span>
                <span className='value'>{item?.bizId}</span>
              </div>
              {
                [2].includes(item?.effectiveState) && <>
                  <div className='item'>
                    <span className='label'>失效时间</span>
                    <span className='value'>{formatTs(item?.invalidTime)}</span>
                  </div>
                  <div className='item'>
                    <span className='label'>失效原因</span>
                    <span className='value'>{item?.cancelReason}</span>
                  </div>
                </>
              }
            </div>
            {
              // LARK-商城购买，THOR-雷神后台赠送
              item?.source === 'LARK' && (
                <div className='bottom-bar' onClick={() => clickOrderEntry(item)}>
                  <div className='text'>购买订单</div>
                  <img alt='' src={require('../../assets/icon_right.png')} className='icon-right' />
                </div>
              )
            }
          </div>
        )) : (!isXpOwner && <NoRecords type='card' />)
      }
    </>
  }

  const renderCouponPackRecords = () => {
    const _formatCouponPackContent = (couponPackDetails: any[]) => {
      const retArr: string[] = []
      couponPackDetails?.length > 0 && couponPackDetails.forEach((item) => {
        retArr.push(`${item?.couponPlanName}(${item?.pushQuantity}张)`)
      })
      return retArr.join('、')
    }
    return <>
      {
        couponPackRecords?.length > 0 ? couponPackRecords.map((item, index) => (
          <div className={`coupon-card-box ${index === 0 ? 'mt-first' : '' }`} key={index}>
            <div className='title-bar'>
              <span className='info-left'>
                <img src={item?.goodsType === 2 ? ICON_MAP['coupon'] : ICON_MAP['storedCard']} alt='' className='icon' />
                <span className='title'>
                  {item?.goodsType === 2 ? ` VIP券包 ( 券数量: ${item?.couponNum}张 )`: `VIP电卡 ( 面额: ${item?.pqAmt}元 )`}
                </span>
              </span>
              <span className={`status ${COUPON_STATE_MAP[item?.goodsStatus][1]}`}>{item?.goodsStatusName}</span>
            </div>
            <div className='content'>
              <div className='item'>
                <span className='label'>获得方式</span>
                <span className='value orange'>{item?.sourceName}</span>
              </div>
              <div className='item'>
              <span className='label'>获得时间</span>
              <span className='value'>{formatTs(item?.giveTime)}</span>
            </div>
              <div className='item'>
                <span className='label'>获得内容</span>
                { item?.goodsType === 2 && <span className='value'>{item.couponPackName}：{_formatCouponPackContent(item?.couponPackPlanRefDetails)}</span>}
                { item?.goodsType === 3 && <span className='value'>{item.pqName}（1张）</span>}
              </div>
              <div className='item'>
                <span className='label'>发放编号</span>
                <span className='value'>{item?.bizId}</span>
              </div>
              {
                [2].includes(item?.goodsStatus) && <>
                  <div className='item'>
                    <span className='label'>失效时间</span>
                    <span className='value'>{formatTs(item?.invalidTime)}</span>
                  </div>
                  <div className='item'>
                    <span className='label'>失效原因</span>
                    <span className='value'>{item?.invalidReasonName}</span>
                  </div>
                </>
              }
            </div>
            {
              // BUY_COUPON_PACK-购买获得，BUY_CHARGE_VIP-购买充电VIP卡赠送获得，BUY_VIP_GOODS-购买VIP产品, DONATE-转赠获得
              ['BUY_COUPON_PACK', 'BUY_CHARGE_VIP', 'BUY_VIP_GOODS', 'DONATE'].includes(item?.source) && (
                <div className='bottom-bar' onClick={() => clickOrderEntry(item)}>
                  <div className='text'>购买订单</div>
                  <img alt='' src={require('../../assets/icon_right.png')} className='icon-right' />
                </div>
              )
            }
          </div>
        )) : <NoRecords type='coupon' />
      }
    </>
  }

  const NoRecords = ({type}) => {
    const info = {
      card: {
        msg: '暂无充电VIP卡',
        imageUrl: require('../../assets/no_vip_card.png')
      },
      coupon: {
        msg: '暂无充电VIP卡券',
        imageUrl: require('../../assets/no_coupon_pack.png')
      }
    }
    return (
      <div className='no-records'>
        <div className='content'>
          <img alt='' src={info[type].imageUrl} className='default-img' />
          <div className='default-msg'>{info[type].msg}</div>
        </div>
      </div>
    )
  }

  if (isLoading)
    return (
      <LoadingPage />
    )

  if (isLoadingError)
    return (
      <ErrorPlaceholder
        message={errorMsg}
      ></ErrorPlaceholder>
    )

  if (isEmptyPage)
    return (
      <EmptyPlaceholder text={errorMsg}></EmptyPlaceholder>
    )

  return (
    <div className='charge-vip-record' onScroll={onGoodsListScroll} ref={recordsRef}>
      <TabsBar tabItems={tabItems} className='top-bar' />
      {curTab === 'card' && renderMemberCardRecords()}
      {curTab === 'coupon' && renderCouponPackRecords()}
      {
        loadingMore ? (
          <div className='loading-more'>
            <LoadingMore loadingText="正在加载"/>
          </div>
        ) : <div className='bottom-desc'>支持展示最近100条记录</div>
      }
    </div>
  )
}

export default App